import Material from './src/material'
Material.install = (Vue) => {
  Vue.component(Material.name, Material)
}
export default Material



// WEBPACK FOOTER //
// ./packages/material/index.js